var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutofillScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.467 3.99994C12.8538 4.12784 9.57516 4.66216 7.33504 6.89452C5.37446 8.8483 4.71908 11.5948 4.5 15.9999M30.533 3.99994C36.1462 4.12784 39.4248 4.66216 41.665 6.89452C43.6256 8.8483 44.281 11.5948 44.5 15.9999M30.533 44C36.1462 43.8722 39.4248 43.3378 41.665 41.1054C43.6256 39.1516 44.281 36.4052 44.5 32M18.467 44C12.8538 43.8722 9.57516 43.3378 7.33504 41.1054C5.37446 39.1516 4.71908 36.4052 4.5 32",
    stroke: "#394452",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 30L34.5 34M32.5 23C32.5 18.0293 28.4706 13.9999 23.5 13.9999C18.5294 13.9999 14.5 18.0293 14.5 23C14.5 27.9706 18.5294 32 23.5 32C28.4706 32 32.5 27.9706 32.5 23Z",
    stroke: "#394452",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutofillScanner);
export default __webpack_public_path__ + "static/media/autofill-scanner.465fce8f04193d22befe19497cb6c8b3.svg";
export { ForwardRef as ReactComponent };